import React, { Component } from 'react';
import { Link } from "react-router-dom";
import OnedayItem from './onedayitem';
import { AuthContext } from "./../../context/auth";
import {ApiBaseUrl} from '../../constants';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { trackPromise } from 'react-promise-tracker';
import {withSnackbar} from "react-simple-snackbar";

class Cart extends Component{
    perPersonPrice = (persons, per_person_price, fee) => {
        const price = persons * per_person_price;
        const admission_fees = price + (price  * fee / 100) + 0.30 + ((price + (price  * fee / 100)) * 0.029);
        return Math.ceil(admission_fees);
    }

    total = (data) => {
        let total = 0;
        data.forEach(item => {
            if(item.deal.deal_type === 'oneday')
                total += parseInt(item.deal.consumer_order_cost)
            else
                total += this.perPersonPrice(item.consumer_admission_capacity_male, item.deal.consumer_admission_fees_male, item.deal.commission)
        })
        return total;
    }

    static contextType = AuthContext;
    state = {
        data: false,
        total: 0
    }

    blockWeekDay = (date, key) => {

        const day = date.getDay(date);
        const days = [];
        if(!this.state.data[key].deal.sunday_availbility)
            days.push(0)
        if(!this.state.data[key].deal.monday_availbility)
            days.push(1)
        if(!this.state.data[key].deal.tuesday_availbility)
            days.push(2)
        if(!this.state.data[key].deal.wednesday_availbility)
            days.push(3)
        if(!this.state.data[key].deal.thursday_availbility)
            days.push(4)
        if(!this.state.data[key].deal.friday_availbility)
            days.push(5)
        if(!this.state.data[key].deal.saturday_availbility)
            days.push(6)
        return !days.includes(day);
    }

    handleDateChange = (date,key) => {
        let data = [...this.state.data]
        data[key].dateTime = date
        const formattedDate = date.getDate() + '-' + (date.getMonth()+1) + '-' + date.getFullYear();
        data[key].date = formattedDate
        this.setState({
            data: data
        }, function(){
            this.updateToCart(data[key],'change',key)
        });
    }

    onPlusClickHandler = (key) => {
        let data = [...this.state.data]
        data[key].consumer_admission_capacity_male += 1
        this.updateToCart(data[key], 'plus', key)
        /*this.setState({
            data: data
        }, function (){
            this.updateToCart(data[key])
        });*/
    }

    onMinusClickHandler = (key) => {
        let data = [...this.state.data]
        if(data[key].consumer_admission_capacity_male > 1) {
            data[key].consumer_admission_capacity_male -= 1
            this.setState({
                data: data
            }, function(){
                this.updateToCart(data[key],'minus',key)
            });
        }
    }

    updateToCart = (data, from, key) => {
        trackPromise(
            fetch(ApiBaseUrl+"/consumer/allday/update_to_cart/",
                {
                    method: 'POST',
                    body: 'item_id='+data._id+'&date='+data.date+'&consumer_admission_capacity_male='+data.consumer_admission_capacity_male,
                    headers:
                        {
                            "Content-Type": "application/x-www-form-urlencoded",
                            "Authorization": "Bearer "+this.context.token
                        }
                })
                .then(res => res.json())
                .then(
                    (result) => {
                        if(result.success === false) {
                            if(from === 'plus'){
                                let data = [...this.state.data]
                                if(data[key].consumer_admission_capacity_male > 1)
                                    data[key].consumer_admission_capacity_male -= 1
                            }
                            else if(from === 'minus'){
                                let data = [...this.state.data]
                                data[key].consumer_admission_capacity_male += 1
                            }
                            this.props.openSnackbar(result.message)
                        }
                        else {
                            this.props.openSnackbar('Cart updated successfully')
                            this.setCartData(result.data)
                        }
                    },
                    // Note: it's important to handle errors here
                    // instead of a catch() block so that we don't swallow
                    // exceptions from actual bugs in components.
                    (error) => {
                        this.props.openSnackbar('Oops, something went wrong.')
                    }
                )
        )
    }

    handleRemoveCartItem = (id) => {
        trackPromise(
        fetch(ApiBaseUrl+"/consumer/remove_from_cart/"+id,
            {
                method: 'GET',
                headers:
                    {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": "Bearer "+this.context.token
                    }
            })
            .then(res => res.json())
            .then(
                (result) => {
                    this.props.openSnackbar(result.message)
                    if(result.success === true) {
                        document.querySelector('.cart-badge').innerHTML = result.data.deals.length
                        this.setCartData(result.data.deals)
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
        )
    }

    handleSubmit = (event) => {
        event.preventDefault()
        let data = {payment:0, deals:[], validForPromo: false}
        this.state.data.forEach(item => {
            if(item.deal.deal_type==='oneday') {
                data.payment += parseInt(item.deal.consumer_order_cost)
                data.deals.push({deal_id: item.deal_id, date: item.date})
                if(parseInt(item.deal.consumer_order_cost) > 20)
                    data.validForPromo = true;
            }
            else {
                data.payment += this.perPersonPrice(item.consumer_admission_capacity_male,item.deal.consumer_admission_fees_male,item.deal.commission)
                data.deals.push({
                    deal_id: item.deal_id,
                    date: item.date,
                    consumer_admission_capacity_male: item.consumer_admission_capacity_male
                })
                if(this.perPersonPrice(item.consumer_admission_capacity_male,item.deal.consumer_admission_fees_male,item.deal.commission) > 20)
                    data.validForPromo = true
            }
        })
        this.props.history.push({ pathname: process.env.PUBLIC_URL+'/cart/payment', state: { data: data }});
    }

    setCartData = (data) => {
        if(data.length) {
            data.forEach((item, key) => {
                if (item.deal.deal_type === 'allday') {
                    let availbility = [];
                    let datePieces = item.date.split("-");
                    let preFinalDate = new Date(parseInt(datePieces[2]), parseInt(datePieces[1]) - 1, parseInt(datePieces[0]));
                    data[key].dateTime = preFinalDate;

                    if (item.deal.monday_availbility)
                        availbility.push('Mon')
                    if (item.deal.tuesday_availbility)
                        availbility.push('Tue')
                    if (item.deal.wednesday_availbility)
                        availbility.push('Wed')
                    if (item.deal.thursday_availbility)
                        availbility.push('Thu')
                    if (item.deal.friday_availbility)
                        availbility.push('Fri')
                    if (item.deal.saturday_availbility)
                        availbility.push('Sat')
                    if (item.deal.sunday_availbility)
                        availbility.push('Sun')
                    data[key].availbility = availbility;
                }
            })
        }
        this.setState({
            data: data
        });
        localStorage.setItem('silverbackCartCount', data.length);
        this.context.cartCount=data.length;
    }

    handleOtherDate = (event,remove_id) => {
        trackPromise(
            fetch(ApiBaseUrl+"/consumer/update_to_cart/",
                {
                    method: 'POST',
                    body: 'item_id='+remove_id+'&deal_id='+event.target.value,
                    headers:
                        {
                            "Content-Type": "application/x-www-form-urlencoded",
                            "Authorization": "Bearer "+this.context.token
                        }
                })
                .then(res => res.json())
                .then(
                    (result) => {
                        if(result.success === false)
                            this.props.openSnackbar(result.message)
                        else
                            this.props.openSnackbar('Cart updated successfully')
                        this.setCartData(result.data)
                    },
                    // Note: it's important to handle errors here
                    // instead of a catch() block so that we don't swallow
                    // exceptions from actual bugs in components.
                    (error) => {
                        this.props.openSnackbar('Oops, something went wrong.')
                    }
                )
        )
    }

    componentDidMount(){
        window.scrollTo(0, 0)
        trackPromise(
            fetch(ApiBaseUrl+"/consumer/cart/",
                {
                    method: 'GET',
                    headers:
                        {
                            "Content-Type": "application/x-www-form-urlencoded",
                            "Authorization": "Bearer "+this.context.token
                        }
                })
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setCartData(result.data)
                    },
                    // Note: it's important to handle errors here
                    // instead of a catch() block so that we don't swallow
                    // exceptions from actual bugs in components.
                    (error) => {
                        this.props.openSnackbar('Oops, something went wrong.')
                    }
                )
        )
    }

    render(){
        return (
            <React.Fragment>
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css" />
                {this.state.data &&
                <div className="choose-deals-outer p-l-0 p-r-0">
                    <div className="container">
                        {this.state.data.length ?
                            <div className="row">
                                <div className=" col-lg-9 col-md-12 col-sm-12 mx-auto px--xs-0">
                                    <div className="my-cart--all-outer">
                                        {this.state.data.map((item, key) =>
                                            (
                                                <div key={key} className="each-cartitem-row bg-17">
                                                    {item.deal.deal_type === 'oneday' ? <OnedayItem handleOtherDate={(event,remove_id) => this.handleOtherDate(event,remove_id)} item={item}
                                                                                                    handleRemoveCartItem={this.handleRemoveCartItem}/> :
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <p className="each-cartitem-label">Per Person Deal</p>
                                                            </div>
                                                            <div className="col-12 col-sm-5 col-lg-6 col-md-6">
                                                                <div className="d-lg-flex d-md-flex d-mob-flex">
                                                                    <div className="cart-image-outer-col">
                                                                        <img src={item.deal.image} alt={item.deal.name}/>
                                                                    </div>
                                                                    <div className="cart-info-sec">
                                                                        <p className="cart-deal-sec-text text_color_green">{item.deal.category.name}</p>
                                                                        <p className="cart-deal-sec-text custom-height">{item.deal.name}</p>
                                                                        <p className="cart-deal-sec1-text custom-height">{item.deal.subtitle}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div
                                                                className="col-12 col-sm-7 col-lg-6 col-md-6 pl-lg-0 pp-margin-top">
                                                                <div className="column--large">
                                                                    <div className="d-flex">
                                                                        <p className="cart-deal-available width-50">Deal
                                                                            available on :</p>
                                                                        <p className="cart-deal-available width-50">{item.availbility.join(', ')}</p>
                                                                    </div>

                                                                    <div className="date-cart-width">
                                                                        <span
                                                                            className="date_label width-50 mr-0">Date:</span>
                                                                        <div className="date-icon width-50">
                                                                            <i className="fa fa-calendar"></i>
                                                                        <DatePicker
                                                                            maxDate={new Date(new Date().getFullYear()+1, new Date().getMonth(), new Date().getDate())}
                                                                            showPopperArrow={false}
                                                                            selected={this.state.data[key].dateTime}
                                                                            placeholderText="DD-MM-YYYY"
                                                                            onChange={date => this.handleDateChange(date, key)}
                                                                            filterDate={date => this.blockWeekDay(date,key)}
                                                                            minDate={new Date()}
                                                                            dateFormat="dd-MM-yyyy"
                                                                        />
                                                                        </div>
                                                                    </div>
                                                                    <div className="outer-setting--commmon">
                                                                        <span
                                                                            className="pp-text-box width-50 mr-0">Per Person :</span>
                                                                        <div className="input_div">
                                                                            <input type="button" value="-" id="moins"
                                                                                   onClick={() => this.onMinusClickHandler(key)}
                                                                                   className="minus"/>
                                                                            <input type="text" size="25"
                                                                                   value={this.state.data[key].consumer_admission_capacity_male}
                                                                                   id="count" readOnly
                                                                                   className="count__val"/>
                                                                            <input type="button" value="+" id="plus"
                                                                                   onClick={() => this.onPlusClickHandler(key)}
                                                                                   className="plusin"/>
                                                                        </div>
                                                                    </div>
                                                                    <div className="mycart-deal--price d-flex">
                                                                        <span
                                                                            className="mycart-deal--price-text width-50 mr-0">Deal price :</span>
                                                                        <span
                                                                            className="mycart-deal--price-text text_color_green width-50 mr-0">${this.perPersonPrice(item.consumer_admission_capacity_male, item.deal.consumer_admission_fees_male, item.deal.commission)}</span>
                                                                    </div>
                                                                    <div className="cart-page-btn mt-3 d-flex">
                                                                        <div className="delete-btn-col d-inline-block">
                                                                            <button
                                                                                onClick={() => this.handleRemoveCartItem(item._id)}
                                                                                type="button"
                                                                                className="btn--del w-auto"><i
                                                                                className="fa fa-trash-o mr-2"
                                                                                aria-hidden="true"></i>Delete
                                                                            </button>
                                                                        </div>
                                                                    <Link to={process.env.PUBLIC_URL+'/allday/deal/' + item.deal._id}><button type="button"
                                                                                className="grad-on cart-view-btn"><i
                                                                            className="fa fa-eye mr-2"
                                                                            aria-hidden="true"></i> View Details
                                                                        </button></Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>}
                                                </div>)
                                        )}
                                    </div>
                                </div>
                                <div className="col-xl-3 px--xs-0">
                                    <div className="search-box-outer table--field-thumb bg-17">
                                        <h4 className="cart-heading-top text-center pt-0">Price Details</h4>
                                        <form autoComplete="off" action="" onSubmit={this.handleSubmit}>
                                            <table className="cart_buy-table">
                                                <tbody>
                                                {this.state.data.map(item => (
                                                    <tr key={item.deal._id}>
                                                        <td>{item.deal.name}</td>
                                                        <td className="cart-td-price float-right">
                                                            ${item.deal.deal_type === 'oneday' ? item.deal.consumer_order_cost : this.perPersonPrice(item.consumer_admission_capacity_male, item.deal.consumer_admission_fees_male, item.deal.commission)}</td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                                <tfoot>
                                                <tr>
                                                    <td>TOTAL PRICE</td>
                                                    <td className="cart-td-price float-right"><span
                                                        className="my-element animate__animated animate__heartBeat repeat green-color">${this.total(this.state.data)}</span>
                                                    </td>
                                                </tr>
                                                </tfoot>
                                            </table>

                                            <div className="text-left text-center mt-3 custom-float right-align-sm">
                                                <input type="submit" value="Buy Now" className="grad-on "/>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className="cart-bottom-navigation">
                                    <div className="cart-total-price">total price</div>
                                    <ul className="">
                                        <li className="cart-bottomlink-container">
                                            <span
                                                className="my-element animate__animated animate__heartBeat repeat">${this.total(this.state.data)}</span>
                                        </li>
                                        <li className="cart-bottomlink-container buy-now-footer">
                                            <a href="/" onClick={this.handleSubmit}><span>buy now</span></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            :
                            <div className="col-12 text-center text-white">
                                Cart is empty
                            </div>
                        }
                    </div>
                </div> }
            </React.Fragment>
        )
    }
}

export default withSnackbar(Cart,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});